module.exports = __webpack_public_path__ + "img/lebron-17-big-kids-shoe.5848b220.png";